module.exports = __webpack_public_path__ + "static/banner-desktop-01-ddf767a7046186fee64f35632c66f516.png";